import React, { useEffect, useMemo, useRef, useState } from 'react'
import Loading from '../feedback/Loading'
import toast from 'react-hot-toast'
import utils from '../../utils'
import { HiTrash } from 'react-icons/hi'
import adminServices from '../../services/AdminServices'
import productServices from '../../services/ProductsServices'
import { useSession } from '../../context/SessionContext'
import moment from 'moment'

function ProductTypeModal(props) {
    const [name, setName] = useState("")
    const [image, setImage] = useState()
    const [loading, setLoading] = useState(false)
    const [deleteLoading, setDeleteLoading] = useState(false)
    const action = props.action
    const activeProductType = props.activeProductType
    const fileInputRef = useRef(null)
    const { setProductTypes } = useSession()
    const [activeTab, setActiveTab] = useState(0);

    // Tabs logic
    const tabs = useMemo(() => {
        const baseTabs = ['Info'];
        if (action === 1) {
            return [...baseTabs, 'Delete'];
        }
        return baseTabs;
    }, [action]);


    useEffect(() => {
        if (action === 1 && activeProductType) {
            setName(activeProductType?.name)
        }
    }, [action, activeProductType])

    const handleFileChange = (event) => {
        const file = event.target.files[0];
        if (file && !file.type.startsWith("image/")) {
            alert("Please select a valid image file.");
            event.target.value = "";
        }
        setImage(file)
    }

    async function updateSession() {
        productServices.getProductTypes().then(
            res => {
                setProductTypes(res.data)
            },
            err => {
                console.log("Session update error");
                console.log(err);
            }
        )
    }

    function submitHandler(e) {
        const closeBtn = document.getElementById("product-type-modal-close-btn")
        e.preventDefault()
        setLoading(true)
        const formData = new FormData()
        formData.append("name", name)
        if (image) {
            formData.append("image", image)
        }
        if (action === 1) {
            adminServices.updateProductType(activeProductType?.id, formData).then(
                res => {
                    toast.success("Product Type Updated Successfully")
                    setLoading(false)
                    props.getProductTypes()
                    updateSession()
                    closeBtn.click()
                },
                err => {
                    toast.error(utils.toastError)
                    console.log(err);
                    setLoading(false)
                }
            )
        } else {
            productServices.addProductType(formData).then(
                res => {
                    toast.success("Product Type Added Successfully")
                    setLoading(false)
                    props.getProductTypes()
                    updateSession()
                    closeBtn.click()
                },
                err => {
                    toast.error(utils.toastError)
                    console.log(err);
                    setLoading(false)
                }
            )
        }
    }
    function clearInput() {
        setName("")
        if (fileInputRef.current) {
            fileInputRef.current.value = ""
        }
    }
    function deleteHandler(id) {
        const closeBtn = document.getElementById("product-type-modal-close-btn")
        setDeleteLoading(true)
        adminServices.deleteProductType(id).then(
            res => {
                toast.success("Product Type Deleted Successfully")
                setDeleteLoading(false)
                props.getProductTypes()
                updateSession()
                closeBtn.click()
            },
            err => {
                toast.error(utils.toastError)
                console.log(err);
                setDeleteLoading(false)
            }
        )
    }
    const changeTab = (idx) => {
        if (action === 1) {
            setActiveTab(idx);
        }
    };
    return (
        <div>
            <label htmlFor="product-type-modal" id='product-type-open-btn' className="hidden">Add / Update Category</label>
            <input type="checkbox" id="product-type-modal" className="modal-toggle" />
            <div className="modal">
                <div className="modal-box w-8/11 max-w-2xl">
                    <label
                        onClick={() => {
                            setActiveTab(0)
                            clearInput()
                        }}
                        htmlFor="product-type-modal"
                        id='product-type-modal-close-btn'
                        className="btn btn-sm btn-circle btn-ghost absolute right-2 top-2">✕</label>
                    <h2 className='text-lg font-bold mb-2'>{action === 1 ? 'View' : 'Add'} Category {action === 1 && activeProductType && (<span className='ml-2 text-gray-500'>{activeProductType?.name}</span>)}</h2>

                    <div className="flex justify-center mb-6">
                        <div className="border-gray-200 dark:border-border-dark">
                            <div className="tabs tabs-boxed justify-center">
                                {tabs.map((tab, idx) => (
                                    // eslint-disable-next-line jsx-a11y/anchor-is-valid
                                    <a
                                        key={idx}
                                        className={`tab ${activeTab === idx
                                            ? 'tab-active bg-primary text-white rounded-lg'
                                            : ''
                                            }`}
                                        onClick={() => changeTab(idx)}
                                        role="tab"
                                        aria-selected={activeTab === idx}
                                    >
                                        {tab}
                                    </a>
                                ))}
                            </div>
                        </div>
                    </div>

                    {activeTab === 0 && (
                        <>
                            {(action === 1 && activeProductType) ? (
                                <div className='mb-4 grid grid-cols-1 gap-3 md:grid-cols-2'>
                                    <div className="flex justify-center">
                                        {activeProductType?.image ? (
                                            <img
                                                src={activeProductType?.image}
                                                alt="product type"
                                                className='rounded-md h-36' />
                                        ) : (
                                            <div className="avatar placeholder">
                                                <div className="bg-neutral text-neutral-content text-lg rounded-md h-20 w-20">
                                                    {String(activeProductType?.name).charAt(0).toLocaleUpperCase()}
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                    <div className='border p-3 rounded-lg shadow-md'>
                                        <p className="font-bold mb-1">Overview</p>
                                        <div>
                                            <p><span className='font-bold  mr-2'>Product Count:</span> {activeProductType?.product_count}</p>
                                        </div>
                                        <p>Created On: <span className='font-bold ml-3 text-gray-600'>{moment(activeProductType?.creation_time).format("MMM Do YYYY")}</span></p>

                                    </div>
                                </div>
                            ) : null}
                            <form onSubmit={submitHandler}>
                                <div className="form-control mb-3">
                                    <label className="label">
                                        <span className="label-text">Name:</span>
                                    </label>
                                    <input
                                        value={name}
                                        onChange={(e) => setName(e.target.value)}
                                        type="text"
                                        required
                                        className="input input-bordered w-full " />
                                </div>
                                {action === 0 ? (
                                    <div className="form-control w-full mb-3">
                                        <label className="label">
                                            <span className="label-text">Image: *</span>
                                        </label>
                                        <input
                                            ref={fileInputRef}
                                            onChange={(e) => handleFileChange(e)}
                                            required
                                            type="file"
                                            accept="image/*"
                                            className="file-input file-input-bordered w-full" />
                                    </div>
                                ) : (
                                    <div className="form-control w-full mb-3">
                                        <label className="label">
                                            <span className="label-text">Image:</span>
                                        </label>
                                        <input
                                            ref={fileInputRef}
                                            onChange={(e) => handleFileChange(e)}
                                            type="file"
                                            accept="image/*"
                                            className="file-input file-input-bordered w-full" />
                                    </div>
                                )}
                                <div className='mt-6'>
                                    <button
                                        className="w-full flex justify-center py-3 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-primary hover:bg-red-800 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary disabled:opacity-75"
                                        type="submit"
                                        disabled={loading}
                                    >
                                        {loading ? (
                                            <div>{action === 0 ? 'Adding...' : 'Updating...'}</div>
                                        ) : (<div>{action === 0 ? 'Add' : 'Update'}</div>)}
                                    </button>
                                </div>
                            </form>
                        </>
                    )}

                    {activeTab === 1 && (
                        <>
                            {action === 1 && (
                                <div className="border-base-200">
                                    <div className="bg-white dark:bg-slate-800 rounded-lg shadow-sm border border-border-light dark:border-border-dark overflow-hidden">
                                        <div className="p-6 md:p-8">
                                            <div className="border-l-4 border-error pl-4 py-2">
                                                <h3 className="font-bold text-error">Warning</h3>
                                                <p className="text-sm text-gray-600 dark:text-gray-400 mt-2">
                                                    Deleting this product is irreversible and may affect orders/inventory.
                                                </p>
                                                <div className="pt-4">
                                                    {deleteLoading ? (
                                                        <Loading />
                                                    ) : (
                                                        <button
                                                            type="button"
                                                            onClick={() => deleteHandler(activeProductType?.id)}
                                                            className="flex items-center space-x-2 bg-error text-white px-4 py-2 rounded-lg text-sm font-medium hover:bg-error/90 transition-colors"
                                                        >
                                                            <HiTrash className="h-4 w-4" />
                                                            <span>Delete Product</span>
                                                        </button>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )}
                        </>
                    )}



                </div>
            </div>
        </div>
    )
}

export default ProductTypeModal